module.exports = __webpack_public_path__ + "img/khalImg4.604a8ad4.png";